import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ManualVoucherApprovalHistory } from '@/entities/manual-voucher-approval'

export const Route = createFileRoute(
  '/_auth/applications/manual-voucher-approval/$manualVoucherId/history'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <ManualVoucherApprovalHistory />
      <Outlet />
    </>
  )
}
